import { Entities, getEntities, patch } from 'src/common';
import { getOwnCompany } from 'src/selectors/bus-companies';
import { connect } from 'react-redux';
import { findOwnBusRequests } from 'src/actions/bus-requests';
import BusRequestAdministration from 'src/components/administration/bus-request/bus-request-administration';
import { push } from 'react-router-redux';
import { addNotification } from 'src/actions/notifications';

const mapStateToProps = state => {
    return {
        busRequests: getEntities(state, Entities.BUS_REQUESTS),
        selectedCompany: state.selectedCompany,
        busCompany: getOwnCompany(state),
    };
};

const mapDispatchToProps = dispatch => {
    return {
        findOwnBusRequests: (selectedCompany, filter) => {
            dispatch(findOwnBusRequests(selectedCompany, filter));
        },
        push: (location, state) => {
            dispatch(push(location, state));
        },
        patch: (body, entity, reducerIndex) => {
            dispatch(patch(body, entity, reducerIndex));
            // dispatch(selectEvent(''));
        },
        addNotification: (title, message, level, position) => {
            dispatch(addNotification(title, message, level, position));
        },
    };
};

const BusRequestAdministrationContainer = connect(mapStateToProps, mapDispatchToProps)(BusRequestAdministration);
export default BusRequestAdministrationContainer;
